"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var rebass_1 = require("rebass");
var BotaoDePagina_1 = require("./BotaoDePagina");
var Divisor_1 = require("./Divisor");
function Paginador(_a) {
  var total = _a.total,
    indiceDoAtivo = _a.indiceDoAtivo,
    aoClicarNaPagina = _a.aoClicarNaPagina;
  return react_1.default.createElement(rebass_1.Flex, {
    className: "paginador",
    alignItems: "center"
  }, lodash_1.range(1, total + 1).map(function (label, indice, array) {
    return react_1.default.createElement(react_1.Fragment, {
      key: indice
    }, react_1.default.createElement(BotaoDePagina_1.BotaoDePagina, {
      onClick: function () {
        return aoClicarNaPagina(indice);
      },
      rotulo: label.toString(),
      ativo: indiceDoAtivo === indice
    }), indice + 1 < array.length && react_1.default.createElement(Divisor_1.Divisor, null));
  }));
}
exports.default = Paginador;